import React from 'react';
import cn from 'classnames';

import BondsTileTools from './BondsTileTools';
import BondTypes from '../BondTypes';
import SearchContainer from '@/finsight/ui/components/bonds/common/SearchContainer';
import CheckUserAccess from 'src/finsight/ui/common/components/CheckUserAccess';
import TileHeaderFallback from '@/finsight/ui/components/bonds/BondsTile/TileHeader/TileHeaderFallback';

import styles from './tileHeader.scss';
import spacesStyles from '@dealroadshow/uikit/core/styles/helpers/spaces.scss';
import tabsStyles from '@dealroadshow/uikit/core/styles/tabs.scss';

const tooltipContent = 'Analyze actionable securities in the US ABS secondary '
    + 'markets on the BWIC & Inventory Monitor.';

interface ITileHeaderProps {
  userAccessChecks: boolean[],
}

const TileHeader = ({ userAccessChecks }: ITileHeaderProps) => (
  <div className={ styles.headerContainer }>
    <CheckUserAccess
      checks={ userAccessChecks }
      fallback={ <TileHeaderFallback tooltipContent={ tooltipContent } /> }
    >
      <>
        <div className={ cn(styles.headerContent, styles.headerWithoutTools) }>
          <div className={ cn(styles.headerTitle, styles.isUserLogged) }>
            <div className={ styles.headerTitleTextWithTools }>
              <h3 className={ spacesStyles.mn } data-test="bondsTileTitleMobile">B&I</h3>
              <h3 className={ spacesStyles.mn } data-test="bondsTileTitleDesktop">BWICS & Inventory</h3>
            </div>
            <BondsTileTools isVisible />
          </div>
          <div className={ cn(styles.statusToolsContainer, styles.isUserLogged) }>
            <SearchContainer />
          </div>
        </div>
        <BondTypes />
        <div className={ tabsStyles.tabsFooter } />
      </>
    </CheckUserAccess>
  </div>
);

export default TileHeader;
